<div [formGroup]="form">

  <div class="form-group label">
    <!-- <label class="question-label">{{question.label}}</label> -->
    <!-- <span *ngIf="question.required" class="mandatory">*</span> -->
    <p-chip [inputId]="question.id || question.key"  *ngIf="question?.chips && question?.placeholder" class="chip" label="i" pTooltip="{{question.placeholder}}"
      tooltipPosition="right"></p-chip>
  </div>

  <div [ngSwitch]="question?.controlType?.toLowerCase()">

    <!--RADIOBUTTON MONO -->

    <div *ngSwitchCase="'radiomono'" class="active singlecheckbox single_col radiobutton" style="margin: 0;">
      <!-- <div *ngFor="let opt of question.options ; index as i" class="{{i > 0 ? 'ml-15' : ''}}"> -->
        <input
          name="{{question.key}}" id="{{ question.id || question.key }}" [value]="true"
          [formControlName]="question.key"
          type="radio" (click)="emit({key:question.key, event:$event.target.checked});">
        <label for="{{ question.id || question.key}}">
          {{question.label}}
        </label>
      <!-- </div> -->
    </div>

    <!-- RADIOBUTTON INPUT -->

    <div *ngSwitchCase="'radio'">
      <label *ngIf="question.label">{{ question.label }}</label>
      <span *ngIf="question.required" class="mandatory">*</span>
      <div class="form-group flex-item d-flex ">
        <div *ngFor="let opt of question.options ; index as i" class="{{i > 0 ? 'ml-15' : ''}}">
          <p-radioButton [inputId]="opt.id" (onClick)="emit({key:question.key, event:$event.value})" [value]="opt.value"
            [formControlName]="question.key"></p-radioButton>
          <label [attr.for]="opt.id" class="ml-2  mb-0">{{ opt.label }}</label>
        </div>
      </div>
    </div>

    <!-- CHECKBOX INPUT -->

    <div *ngSwitchCase="'checkbox'" class="form-group flex-item d-flex ">
      <div *ngFor="let opt of question.options ; index as i" class="{{i > 0 ? 'ml-15' : ''}}">
        <p-checkbox [inputId]="opt.id"  (onChange)="emit({key:question.key, event:$event.checked})" [value]="opt.value"
          [formControlName]="question.key"></p-checkbox>
        <label [attr.for]="opt.id" class="ml-2 mb-0">{{ opt.label }}</label>
      </div>
    </div>


    <!-- TEXT INPUT -->
    <div *ngSwitchCase="'text'" class="form-group">
      <label [attr.for]="question.id || question.key">
        {{question.label}}
        <span *ngIf="question.required" class="mandatory">*</span>
      </label>
      <input [attr.id]="question.id || question.key"  (change)="emit({key:question.key, event:$event.target.value})"
        pTooltip="{{question.tooltip}}" tooltipPosition="bottom"
        [placeholder]="question.placeholder ? question.placeholder : 'Inserisci un valore'"
        [formControlName]="question.key" class="form-control" type="text">
    </div>

    <!-- TEXT BOX INPUT -->
    <div *ngSwitchCase="'textbox'" class="form-group">
      <label [attr.for]="question.id || question.key">
        {{question.label}}
        <span *ngIf="question.required" class="mandatory">*</span>
      </label>
      <textarea [attr.id]="question.id || question.key" rows="1" cols="30" pInputTextarea [formControlName]="question.key"
        [placeholder]="question.placeholder ? question.placeholder : 'Inserisci un valore'"
        (change)="emit({key:question.key, event:$event.target.value})" [autoResize]="true"></textarea>
    </div>

    <!-- LABEL INPUT -->
    <div *ngSwitchCase="'chips'" class="form-group">
      <label [attr.for]="question.id || question.key">
        {{question.label}}
        <span *ngIf="question.required" class="mandatory">*</span>
      </label>
      <p-chips [inputId]="question.id || question.key" class="label" [formControlName]="question.key" [separator]="','"
      [allowDuplicate]="false" [addOnBlur]="true" [showClear]="true"
      [placeholder] = "'Inserisci un\'etichetta'"
      (onAdd)="onChipsAdd($event.value)"
      (onRemove)="onChipsRemove($event.value)"
      (onClear)="onChipsClear()"
      (onBlur)="onChipsBlur()"></p-chips>
    </div>


    <!-- MULTI SELECT INPUT -->
    <div *ngSwitchCase="'multi'" class="form-group">
        <label [attr.for]="question.key">
          {{question.label}}
          <span *ngIf="question.required" class="mandatory">*</span>
        </label>
      <p-multiSelect [inputId]="question.key" class="multiSelect" [options]="question.options" optionValue="value"
        [formControlName]="question.key" optionLabel="label" placeholder="Seleziona"
        (onChange)="onMultySelect({key: question.key, event: $event})"></p-multiSelect>

    </div>

    <!-- CURRENCY INPUT -->
    <div *ngSwitchCase="'currency'" class="form-group">
      <label [attr.for]="question.key">
        {{question.label}}
        <span *ngIf="question.required" class="mandatory">*</span>
      </label>
      <div class="d-flex">
        <span class="input-group-text">€</span>
        <p-inputNumber  [inputId]="question.key"class="currency" (onBlur)="emit({key: question.key, event: $event.target.value})" currency="EUR"
          [formControlName]="question.key" mode="decimal" [minFractionDigits]="2" placeholder="0.00"
          [maxFractionDigits]="2">
        </p-inputNumber>
      </div>

    </div>


    <!-- BASIC SELECT -->
    <div *ngSwitchCase="'dropdown'" class="form-group">
      <label [attr.for]="question.id || question.key">
        {{question.label}}
        <span *ngIf="question.required" class="mandatory">*</span>
      </label>
      <select [attr.id]="question.id || question.key" class="form-control" (change)="emit({key: question.key, event: $event.target.value})"
        [formControlName]="question.key">
        <option *ngIf="!question.noEmptyOption" [ngValue]="null">{{question.placeholder}}</option>
        <option *ngFor="let opt of question.options" style="color: #3a3a3a" [value]="opt.value || opt.label">{{opt.label}}</option>
      </select>
    </div>

    <!-- FILTERED SELECT -->
    <div *ngSwitchCase="'searchable_dropdown'" class="form-group">
      <label [attr.for]="question.id || question.key">
        {{question.label}}
        <span *ngIf="question.required" class="mandatory">*</span>
      </label>
      <p-dropdown [inputId]="question.id || question.key"  class="searchable-dropdown" (onChange)="emit({key: question.key, event: $event})"
        [options]="question.options" optionValue="value" optionLabel="label"
        [placeholder]="question.placeholder" [filter]="true" filterBy="label"
        (onChange)="emit({key: question.key, event: $event.value})" [formControlName]="question.key" ></p-dropdown>
    </div>


    <!-- DATEPICKER -->
    <div *ngSwitchCase="'date'" class="form-group">
      <!-- <label [attr.for]="question.key">{{question.label}}</label> -->
      <div [placeholder]="question.placeholder ? question.placeholder : 'Inserisci una data'" datePickerInput [disabled]="isDisabled()"
     (onValueChange)="emit({key: question.key, event: $event})" [labelInput]="question.label" [formControlName]="question.key" [control] = "form.get(question.key)"></div>
    </div>

    <!-- SWITCH -->
    <div *ngSwitchCase="'switch'" class="form-group">
      <label [attr.for]="question.id || question.key">
        {{question.label}}
        <span *ngIf="question.required" class="mandatory">*</span>
      </label>
      <p-inputSwitch [inputId]="question.id || question.key" (onChange)="emit({key: question.key, event: $event.checked})"
        [formControlName]="question.key"></p-inputSwitch>
    </div>


    <!-- NUMBER INPUT -->
    <div *ngSwitchCase="'number'" class="form-group">
      <label [attr.for]="question.id || question.key">
        {{question.label}}
        <span *ngIf="question.required" class="mandatory">*</span>
      </label>
      <p-inputNumber [inputId]="question.id || question.key"  (onBlur)="emit({key: question.key, event: $event.target.value})" [showButtons]="true"
        mode="decimal" [useGrouping]="false" [placeholder]="!!question.placeholder ? question.placeholder : '0'" [formControlName]="question.key"> </p-inputNumber>
    </div>

  </div>


  <p *ngIf="hasError(question?.key)" class="form-group  mandatory errors"><em> {{getErrors(question?.key)}}</em></p>

</div>
